module.exports = {"title":"APL 실시간 현황","statsBaseTime":"{time} (통계 기준시간)","byClubCount":"<골프장 수 기준>","total":"전체","normal":"정상","abnormal":"비정상","normalOperationRate":"정상가동률","progressStatus":"진행상태","aplDeviceRate":"APL 디바이스 가동률","normalOfTotal":"정상 {normal} / 전체 {total}","regionGyeonggiIncheon":"경기/인천","regionChungbuk":"충북","regionChungnam":"충남","regionJeolla":"전라","regionGyeongbuk":"경북","regionGyeongnam":"경남","regionGangwon":"강원","regionJeju":"제주"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/ho201.json
// module id = rncG
// module chunks = 2